<template>
  <div class="animated fadeIn py3">
    <div class="clearfix notosans px2 mb2">
      <div class="col-12">
        <!-- <div class="clearfix border muted-border p2 pb4 shadow" v-if="showMobile">
          <div class="col-12 mt3">
            <p class="h4 semi-bold line-height-2 my2">Opdater dine projekter</p>
            <p class="h5 regular darkblue line-height-golden mb3">Opdaterer du dine projekter eller uploader du billeder, så vil ændringerne være synlige for kunderne på håndværker.dk i løbet af 24 timer.</p>

            <haandvaerkerstatuslist @UpdateProject="UpdateProject"></haandvaerkerstatuslist>
          </div>
        </div>
        <div class="clearfix p2 pb4 pl4" v-if="!showMobile && !showXXL">
          <div class="col-12 mt3">
            <p class="h4 semi-bold line-height-2 my2">Opdater dine projekter</p>
            <p class="h5 regular darkblue line-height-golden mb3">Opdaterer du dine projekter eller uploader du billeder, så vil ændringerne være synlige for kunderne på håndværker.dk i løbet af 24 timer.</p>
            <div class="py2"></div>
            <haandvaerkerstatuslist @UpdateProject="UpdateProject"></haandvaerkerstatuslist>
          </div>
        </div> -->
        <div class="clearfix flex flex-column p2 pb4 pl4 mp0">
          <div class="col-12 mt2">
            <p class="h4 semi-bold line-height-2 my2">Opdater dine projekter</p>
            <p class="h5 regular darkblue line-height-golden mb3">Opdaterer du dine projekter eller uploader du billeder, så vil ændringerne være synlige for kunderne på håndværker.dk i løbet af 24 timer.</p>

          </div>
          <div class="col-12 mt3">
            <haandvaerkerstatuslist @UpdateProject="UpdateProject"></haandvaerkerstatuslist>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import haandvaerkerstatuslist from './haandvaerker/NewStatusListnew'
export default {
  components: {
    haandvaerkerstatuslist
  },
  data: function () {
    return {
      url: ''
    }
  },
  methods: {
    UpdateProject (url) {
      this.url = url
    }
  },
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    if (screen.width >= 1300) {
      this.showXXL = true
    } else {
      this.showXXL = false
    }
  }
}
</script>
<style scoped>
.main .container-fluid {
  padding: 15px 0;
}
.fa-heartbeat {
  font-size: 26px;
}
@media screen and (max-width: 450px) {
    .mp0 {
      padding: 0!important;
    }
}
</style>



// WEBPACK FOOTER //
// NewHaandvaerkerProjectStatus2.vue?3c93e40e